import { render } from "./ArtInvestExplanationComponent.vue?vue&type=template&id=404b3f12&scoped=true"
import script from "./ArtInvestExplanationComponent.vue?vue&type=script&lang=js"
export * from "./ArtInvestExplanationComponent.vue?vue&type=script&lang=js"

import "./ArtInvestExplanationComponent.vue?vue&type=style&index=0&id=404b3f12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404b3f12"]])

export default __exports__